import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";

import { Space, Breadcrumb, Card, Button } from "antd";
import { PageHeader } from "@ant-design/pro-layout";

import {
  UserData,
} from "../../model/model";

import UserForm from "./UserForm";
import SessionStore from "../../model/SessionStore";
import DeleteConfirm from "../../components/DeleteConfirm";

function EditUser() {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [userData, setUser] = useState<UserData | undefined>(undefined);

  useEffect(() => {
    
    SessionStore.getClient().getUser(userId!, SessionStore.getBearer()).then((resp) => {
      setUser(resp.data);
    });
  }, [userId]);

  const onFinish = (obj: UserData, password: string) => {
   
    SessionStore.getClient().updateUser(obj, SessionStore.getBearer()).then(() => {
      navigate("/users");
    });
  };

  const deleteUser = () => {
    if (!userData) {
      return;
    }

    SessionStore.getClient().removeUser(userData.login, SessionStore.getBearer()).then( () => {
      navigate("/users");
    });
  };

  if (!userData) {
    return null;
  }

  return (
    <Space direction="vertical" style={{ width: "100%" }} size="large">
      <PageHeader
        breadcrumbRender={() => (
          <Breadcrumb>
            <Breadcrumb.Item>
              <span>Network-server</span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>
                <Link to="/users">Users</Link>
              </span>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <span>{userData.email}</span>
            </Breadcrumb.Item>
          </Breadcrumb>
        )}
        title={userData.email}
        subTitle={`userData id: ${userData.login}`}
        extra={[
          <Button>
            <Link to={`/user/${userData.login}/password`}>Change password</Link>
          </Button>,
          <DeleteConfirm typ="userData" confirm={userData.email} onConfirm={deleteUser}>
            <Button danger type="primary">
              Delete userData
            </Button>
          </DeleteConfirm>,
        ]}
      />
      <Card>
        <UserForm initialValues={userData} onFinish={onFinish} password={false} update/>
      </Card>
    </Space>
  );
}

export default EditUser;
